import { recipe } from '@vanilla-extract/recipes';
import { styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';

export const tone = styleVariants({
  up: { color: vars.bright.status.success },
  down: { color: vars.bright.status.error },
  flat: { color: vars.typography.textColor.tertiary },
});

// semantics="spend" — 지출 도메인: 증가=지출 확대=주의(amber), 감소=안정(green)
export const toneSpend = styleVariants({
  up: { color: vars.bright.status.warning },
  down: { color: vars.bright.status.success },
  flat: { color: vars.typography.textColor.tertiary },
});

export const indicator = recipe({
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '2px',
    fontWeight: vars.typography.fontWeight.semibold,
    fontVariantNumeric: 'tabular-nums',
    lineHeight: 1,
    whiteSpace: 'nowrap',
  },
  variants: {
    size: {
      sm: { fontSize: vars.typography.fontSize.xs },
      md: { fontSize: vars.typography.fontSize.sm },
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});
